
import { Component, Vue } from 'vue-property-decorator'
import HeaderNavigator from '@/components/HeaderNavigator.vue'
import Step1 from '@/components/pages/Step1.vue'
import Step2 from '@/components/pages/Step2.vue'
import Step3 from '@/components/pages/Step3.vue'

import strings from '@/assets/strings.json'
import { Step } from '@/models/Step'
import { MutationTypes } from '@/store/mutation-types'
import { ProductDetail } from '@/models/ProductDetail'

@Component({
  components: {
    HeaderNavigator,
    Step1,
    Step2,
    Step3
  }
})
export default class Navigator extends Vue {
  private steps: Array<Step>;

  private navigatorStrings = strings.Navigator
  private directLink = false;

  get currentStep () {
    return this.$store.state.currentStep
  }

  set currentStep (index: number) {
    this.$store.commit(MutationTypes.CHANGE_CURRENT_STEP, { currentStep: index })
  }

  private goTo (index: number) {
    if (this.steps.length > index) {
      window.VoerroModal.show({
        title: this.navigatorStrings.confirmBackTitle,
        body: this.navigatorStrings.confirmBackDescription,
        buttons: [
          {
            text: this.navigatorStrings.confirmBackOk,
            handler: () => {
              this.currentStep = index
              this.directLink = false
            }
          },
          {
            text: this.navigatorStrings.confirmBackCancel
          }
        ]
      })
    }
  }

  get breadcrumbsSteps () {
    const breadcrumbs: Array<Step> = this.currentStep > 0 ? this.steps.slice(0, this.currentStep) : []
    return breadcrumbs
  }

  constructor () {
    super()

    this.steps = [
      new Step('Step1', strings.Step1.title, strings.Step1.subTitle),
      new Step('Step2', strings.Step2.title, strings.Step2.subTitle),
      new Step('Step3', strings.Step3.title)
    ]

    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())

    if ('base_id' in params) {
      this.directLink = true
      this.$store.commit(MutationTypes.CHANGE_CURRENT_STEP, { currentStep: 2, baseProductId: parseInt(params.base_id) })
    }
  }
}
